import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationToasterService } from 'src/app/services/notification-toaster.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsNotificationService {
  constructor(
    private translateService: TranslateService,
    private notificationToasterService: NotificationToasterService,
  ) {}

  showSuccessSettingsUpdateNotification() {
    this.notificationToasterService.showDefaultSuccessNotification(
      this.translateService.instant('Settings updated!'),
      this.notificationToasterService.generateNotificationCode(),
      true,
    );
  }

  showFailureSettingsUpdateNotification() {
    this.notificationToasterService.showDefaultErrorNotificationV2(
      this.translateService.instant('Update failed'),
      this.translateService.instant('An error occurred. Please try again.'),
      this.notificationToasterService.generateNotificationCode(),
      undefined,
      undefined,
      undefined,
      true,
    );
  }
}
